import {
  SetQueryParams,
  SetSearchParams,
  SetTokenParam,
} from './query-param.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { _Bottom } from '@angular/cdk/scrolling';
import { QueryParamsState } from './query-params.model';

export const initialState: QueryParamsState = {
  queryParams: {
    assetCode: '',
    isCashoutAllowed: true,
    cashoutCountry: '',
    cashoutCurrencies: '',
    operation: '',
    token: '',
    transactionId: '',
    walletProvider: '',
    amount: 0,
    email: '',
    locale: '',
  },
};
export function QueryParamsReducer(
  state: QueryParamsState | undefined,
  action: Action
) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(SetSearchParams, (state, { queryParams }) => ({
    ...state,
    queryParams: queryParams.queryParams,
  })),
  on(SetTokenParam, (state, { queryParams }) => ({
    ...state,
    queryParams: {
      ...state.queryParams,
      token: queryParams.queryParams.token,
      transactionId: queryParams.queryParams.transactionId,
      locale: queryParams.queryParams.locale,
      endpoint: queryParams.queryParams.endpoint,
    },
  }))
);
